import { render, staticRenderFns } from "./SettingAddAdmin.vue?vue&type=template&id=6193db6e&scoped=true&"
import script from "./SettingAddAdmin.vue?vue&type=script&lang=js&"
export * from "./SettingAddAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6193db6e",
  null
  
)

export default component.exports